import { Analytics } from '@vercel/analytics/react';

/**
 * Custom analytics utility to track events in the application
 */

// Track page views
export const trackPageView = (path) => {
  try {
    if (typeof window !== 'undefined' && window.va) {
      window.va('pageview', { path });
    }
  } catch (error) {
    console.error('Error tracking page view:', error);
  }
};

// Track user interactions
export const trackEvent = (eventName, properties = {}) => {
  try {
    if (typeof window !== 'undefined' && window.va) {
      window.va('event', {
        name: eventName,
        ...properties
      });
    }
  } catch (error) {
    console.error('Error tracking event:', error);
  }
};

// Common events
export const trackButtonClick = (buttonName, buttonLocation) => {
  trackEvent('button_click', { buttonName, buttonLocation });
};

export const trackFormSubmit = (formName, success = true) => {
  trackEvent('form_submit', { formName, success });
};

export const trackFormError = (formName, errorField, errorMessage) => {
  trackEvent('form_error', { formName, errorField, errorMessage });
};

export const trackNavigation = (from, to) => {
  trackEvent('navigation', { from, to });
};

export const trackSearch = (query, resultCount) => {
  trackEvent('search', { query, resultCount });
};

export const trackFeatureUsage = (featureName) => {
  trackEvent('feature_usage', { featureName });
};

export const trackSubscriptionAction = (action, plan, price) => {
  trackEvent('subscription', { action, plan, price });
};

// Performance tracking
export const trackResourceLoad = (resourceType, url, duration) => {
  trackEvent('resource_load', { resourceType, url, duration });
};

export default {
  trackPageView,
  trackEvent,
  trackButtonClick,
  trackFormSubmit,
  trackFormError,
  trackNavigation,
  trackSearch,
  trackFeatureUsage,
  trackSubscriptionAction,
  trackResourceLoad
}; 